import React, { useContext, useState, useEffect, useRef } from 'react'
import Layout from '@/product/components/templates/Layout'
import CustomTable from '@/product/components/molecules/CustomTable'
import CustomSearch from '@/product/components/molecules/CustomSearch'
import { Button } from '@mui/material'
import { mapData } from '@/product/common/components'
import { useFormik } from 'formik'
import CustomCommonContext from '@/custom/context/common/commonContext'
import CustomDialog from '@/product/components/organisms/Dialog'

import * as Yup from 'yup'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import SettingContext from '@/product/context/setting/settingContext'

const TaxCodeList = () => {
    const settingcontext = useContext(SettingContext)
    const { allTaxCodeList, getGlobalVariable } =
        useContext(CustomCommonContext)

    const {
        searchTableAction,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [changeStatus, setChangeStatus] = useState(false)
    const [totalLength, setTotatLength] = useState(0)
    const changeChangeStatus = () => {
        setChangeStatus(!changeStatus)
    }

    const [manage, setManage] = React.useState({
        popup: false,
        status: 'new',
        id: 0,
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const [tableBody, setTableBody] = useState([])
    const formikSelection = useFormik({
        initialValues: {
            action: '',
            active: 0,
            id: 0,
            table: 'tax_code_list',
        },
        onSubmit: (values) => {
            const dataValue = values
            if (
                dataValue.action === 'active' ||
                dataValue.action === 'deactive' ||
                dataValue.action === 'delete'
            ) {
                dataValue.active =
                    dataValue.action === 'delete'
                        ? 2
                        : dataValue.action === 'active'
                          ? 1
                          : 0
                delete dataValue.action
                searchTableAction(values)
            }
        },
    })
    const validationArray = Yup.object({
        description: Yup.string().required('Required!'),
    })

    const formikView = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            searchterm: '',
        },
        onSubmit: (values) => {
            values.page = 1
            let filteredValues = allTaxCodeList
            if (values.searchterm && values.searchterm != '') {
                filteredValues = filteredValues.filter(
                    (filter) =>
                        filter.name
                            .toLowerCase()
                            .indexOf(values.searchterm.toLowerCase()) !== -1
                )
            }
            setTotatLength(filteredValues.length)
            var list = []
            let lowEnd = (values.page - 1) * values.limit
            let highEnd = values.page * values.limit - 1
            for (var i = lowEnd; i <= highEnd; i++) {
                if (filteredValues[i]) {
                    list.push(filteredValues[i])
                }
            }
            setTableBody(list)
        },
    })

    const formik = useFormik({
        initialValues: {
            id: 0,
            source: '',
            name: '',
            code: '',
            table: 'tax_code_list',
            active: 1,
        },
        validateOnBlur: false,
        validationSchema: validationArray,
        onSubmit: (values) => {
            console.log('+++++++++++++', values)
            searchTableAction(values)
        },
    })

    const changePagination = () => {
        if (allTaxCodeList.length) {
            let filteredValues = allTaxCodeList
            if (
                formikView.values.searchterm &&
                formikView.values.searchterm != ''
            ) {
                filteredValues = filteredValues.filter(
                    (filter) =>
                        filter.name
                            .toLowerCase()
                            .indexOf(
                                formikView.values.searchterm.toLowerCase()
                            ) !== -1
                )
            }
            setTotatLength(filteredValues.length)
            var list = []
            let lowEnd = (formikView.values.page - 1) * formikView.values.limit
            let highEnd = formikView.values.page * formikView.values.limit - 1
            for (var i = lowEnd; i <= highEnd; i++) {
                if (filteredValues[i]) {
                    list.push(filteredValues[i])
                }
            }
            setTableBody(list)
        }
    }

    useEffect(() => {
        if (allTaxCodeList?.length) {
            var list = []
            let lowEnd = (formikView.values.page - 1) * formikView.values.limit
            let highEnd = formikView.values.page * formikView.values.limit - 1
            for (var i = lowEnd; i <= highEnd; i++) {
                if (allTaxCodeList[i]) {
                    list.push(allTaxCodeList[i])
                }
            }
            setTableBody(list)
            setTotatLength(allTaxCodeList.length)
        }
    }, [allTaxCodeList])

    useEffect(() => {
        if (responseStatusSetting) {
            if (
                responseStatusSetting.from === 'CommunicationSearchTable' &&
                responseStatusSetting.status === 'success'
            ) {
                setChangeStatus(false)
                toggleFullScreenPopup(false)
                setTableBody([])
                getGlobalVariable()
            }
        }
    }, [responseStatusSetting])

    const onClickEdit = (id, secondaryID, type) => {
        toggleFullScreenPopup(true, 'edit', id)
    }

    useEffect(() => {
        console.log('manage', manage)
        if (manage.status === 'edit') {
            formik.setFieldValue('id', manage.id)
            const template = allTaxCodeList.filter(
                (cat) => cat.id === manage.id
            )
            formik.setFieldValue('source', template[0].source)
            formik.setFieldValue('name', template[0].name)
            formik.setFieldValue('code', template[0].code)
        } else {
            resetFrom()
        }
    }, [manage])

    const resetFrom = () => {
        console.log('resetForm')
        formik.setFieldValue('id', 0)
        formik.setFieldValue('name', '')
        formik.setFieldValue('code', '')
        formik.setFieldValue('table', 'tax_code_list')
        formik.handleReset()
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'ID',
        },
        {
            field: 'name',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Name',
        },
        {
            field: 'code',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Code',
        },
        {
            field: 'active',
            condition: true,
            conditionValue: {
                formula: {
                    key1: 'active',
                    key2: 1,
                    notation: '===',
                },
                true: {
                    type: 'text',
                    value: 'Active',
                },
                false: {
                    type: 'text',
                    value: 'Deactive',
                },
            },
            type: 'text',
            sort: true,
            firstChild: false,
            disablePadding: false,
            label: 'Status',
        },
        {
            field: 'action',
            type: 'button',
            clickType: 'edit',
            onclick: onClickEdit,
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            tooltipTitle: 'Edit Tax Code',
        },
    ]
    const details = [
        {
            label: 'Name *',
            placeholder: 'Enter the name',
            type: 'textarea',
            class: 'col-12',
            name: 'name',
            formik: formik,
        },
        {
            label: 'Code *',
            placeholder: 'Enter the code',
            type: 'textarea',
            class: 'col-12',
            name: 'code',
            formik: formik,
        },
        {
            label: 'Active',
            placeholder: 'Make Active',
            type: 'switch',
            class: 'col-6',
            name: 'active',
            formik: formik,
        },
    ]

    const onSelectMultiProducts = (data, action) => {
        formikSelection.values.action = action
        formikSelection.values.id = data
        if (
            action === 'active' ||
            action === 'deactive' ||
            action === 'delete'
        ) {
            setChangeStatus(true)
        }
    }

    const tableActions = []
    tableActions.push(
        {
            label: 'Move to Active',
            icon: <span className="material-icons">check_circle</span>,
            onclick: onSelectMultiProducts,
            type: 'active',
        },
        {
            label: 'Move to Deactive',
            icon: <span className="material-icons">block</span>,
            onclick: onSelectMultiProducts,
            type: 'deactive',
        },
        {
            label: 'Delete Permanently',
            icon: <span className="material-icons">cancel</span>,
            onclick: onSelectMultiProducts,
            type: 'delete',
        }
    )

    const searchInfo = [
        {
            label: 'Search code',
            placeholder: 'Enter serach code',
            class: 'col-md-4 col-sm-6 col-12',
            type: 'text',
            name: 'searchterm',
            formik: formikView,
        },
    ]

    return (
        <Layout>
            <div className="dashboard staticPages">
                <CustomSearch searchInfo={searchInfo} formik={formikView} />
                <div className="d-flex justify-content-between align-items-center mt-4">
                    <Button
                        id="taxCodelist_new"
                        variant="outlined"
                        className="btnOutlined"
                        onClick={() => toggleFullScreenPopup(true, 'new', 0)}
                    >
                        <span className="material-icons">note_add</span>Add New
                        Tax Code
                    </Button>
                </div>

                <CustomTable
                    formik={formikView.values}
                    tableBody={tableBody}
                    tableValues={tableValues}
                    tableActions={tableActions}
                    allData={{
                        records: allTaxCodeList,
                        setDisp: `0-${totalLength}`,
                        totalRecords: totalLength,
                    }}
                    changeTableFunction={changePagination}
                />
            </div>
            <FullScreenPopup
                modaltitle={
                    manage.status === 'new'
                        ? 'Add New Tax Code'
                        : 'Edit Tax Code'
                }
                open={manage.popup}
                handleClose={() => toggleFullScreenPopup(false, 'new', 0)}
            >
                <div className="dashboard addNewListing mt-4">
                    <div className="fspBody">
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <div className="row">
                                {Object.values(mapData(details))}
                            </div>
                            <div className="actionButton d-flex justify-content-center align-items-center">
                                <SecondaryButton
                                    id="tax_reset"
                                    label="Reset"
                                    type="reset"
                                    onClick={() => resetFrom()}
                                />
                                <PrimaryButton
                                    id="taxCode_submit"
                                    type="submit"
                                    label="Submit"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </FullScreenPopup>

            <CustomDialog
                title={'Change status'}
                open={changeStatus}
                function={changeChangeStatus}
            >
                <h5>
                    {formikSelection.values.action === 'delete'
                        ? 'Are you sure you want to delete'
                        : 'Are you sure you want to change the status'}
                </h5>
                <div className="actionWrapper">
                    <Button
                        id="taxCodeList_cancel"
                        onClick={() => changeChangeStatus()}
                    >
                        Cancel
                    </Button>
                    <form
                        onSubmit={formikSelection.handleSubmit}
                        autoComplete="nofill"
                    >
                        <PrimaryButton
                            id="taxCode_confirm"
                            type="submit"
                            label="Confirm"
                        />
                    </form>
                </div>
            </CustomDialog>
        </Layout>
    )
}
export default TaxCodeList
